// hooks/useSettings.js
import { 
  useGetSettingsQuery, 
  useUpdateSettingsMutation, 
  useUpdateLogoMutation,
  useUpdateBannerImageMutation,
  useDeleteImageMutation 
} from "../redux/services/webSettingService/webSite.Services";

export const useSettings = () => {
    const { data, isLoading, error, refetch } = useGetSettingsQuery();
    const [updateSettings, { isLoading: isUpdating }] = useUpdateSettingsMutation();
    const [updateLogo, { isLoading: isUpdatingLogo }] = useUpdateLogoMutation();
    const [updateBannerImage, { isLoading: isUpdatingBanner }] = useUpdateBannerImageMutation();
    const [deleteImage, { isLoading: isDeleting }] = useDeleteImageMutation();

    const settings = data?.data || null;
    const imageBaseUrl = data?.imageBaseUrl || "";

    return {
        settings,
        imageBaseUrl,
        isLoading,
        isUpdating,
        isUpdatingLogo,
        isUpdatingBanner,
        isDeleting,
        error,
        refetch,
        updateSettings,
        updateLogo,
        updateBannerImage,
        deleteImage,
    };
};